import React from 'react';

export default function SkeletonLoader({ type = 'default' }) {
  if (type === 'destination') {
    return (
      <div className="bg-white rounded-lg overflow-hidden shadow animate-pulse p-4">
        <div className="h-48 bg-gray-300 rounded mb-4"></div>
        <div className="h-4 bg-gray-300 rounded mb-2"></div>
        <div className="h-3 bg-gray-300 rounded mb-2 w-3/4"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2"></div>
      </div>
    );
  }

  if (type === 'cruise') {
    return (
      <div className="bg-white rounded-lg overflow-hidden shadow animate-pulse p-4">
        <div className="h-48 bg-gray-300 rounded mb-4"></div>
        <div className="h-5 bg-gray-300 rounded mb-2"></div>
        <div className="h-3 bg-gray-300 rounded mb-2"></div>
        <div className="h-3 bg-gray-300 rounded mb-2 w-2/3"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2"></div>
      </div>
    );
  }

  if (type === 'assistance') {
    return (
      <div className="bg-white rounded-xl shadow-md p-6 animate-pulse">
        <div className="h-6 bg-gray-300 rounded mb-4"></div>
        <div className="h-4 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 bg-gray-300 rounded mb-4 w-3/4"></div>
        <div className="h-10 bg-gray-300 rounded"></div>
      </div>
    );
  }

  // Default skeleton
  return (
    <div className="animate-pulse p-4">
      <div className="h-4 bg-gray-300 rounded mb-2"></div>
      <div className="h-4 bg-gray-300 rounded mb-2 w-5/6"></div>
      <div className="h-4 bg-gray-300 rounded mb-2 w-4/6"></div>
    </div>
  );
}
